package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Option

@Composable
fun <T, U> ConfigFilterGroup(
    title: String,
    items: List<T>,
    selectOptions: List<U>,
    selectedValues: Map<T, U>,
    onSelectionChange: (T, U) -> Unit,
    labelItem: (T) -> String,
    labelOption: (U) -> String,
    breakpoint: Breakpoint
) {

    val isMobile = breakpoint < Breakpoint.MD

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = 10.px)
    ) {

        //  TITRE
        SpanText(
            title,
            modifier = Modifier
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 10.px)
        )

        //  BOX
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .border(1.px, LineStyle.Solid, Colors.LightGray)
                .borderRadius(10.px)
                .padding(15.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            //  GRID (2 colonnes desktop, 1 mobile)
            items.chunked(if (isMobile) 1 else 2).forEach { rowItems ->

                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin( 10.px),
                ) {

                    rowItems.forEach { item ->
                        val currentValue = selectedValues[item] ?: selectOptions.firstOrNull()

                        Row(
                            modifier = Modifier
                                .flexGrow(1) // Espace entre les colonnes,
                                .margin(leftRight = 15.px, topBottom = 10.px),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            // LABEL compétence
                            SpanText(
                                labelItem(item),
                                modifier = Modifier
                                    .fontSize(16.px)
                                    .fontWeight(FontWeight.Medium)
                                    .margin(bottom = 10.px, right = 10.px)
                            )

                            // SELECT niveau
                            Select(
                                attrs = Modifier
                                    .width(120.px)
                                    .padding(6.px)
                                    .borderRadius(6.px)
                                    .border(1.px, LineStyle.Solid, Colors.LightGray)
                                    //.backgroundColor(Colors.White)
                                    .cursor(Cursor.Pointer)
                                    .toAttrs {
                                        onChange { event ->
                                            val selectedIndex = event.target.asDynamic()?.selectedIndex
                                            if (selectedIndex != null && selectedIndex >= 0 && selectedIndex < selectOptions.size) {
                                                onSelectionChange(item, selectOptions[selectedIndex])
                                            }
                                        }
                                    }
                            ) {
                                selectOptions.forEach { option ->
                                    Option(
                                        value = labelOption(option),
                                        attrs = Modifier.toAttrs {
                                            if (currentValue != null && labelOption(currentValue) == labelOption(option)) {
                                                selected()
                                            }
                                        }
                                    ) {
                                        SpanText(labelOption(option))
                                    }
                                }
                            }
                        }
                    }

                    // Remplissage si nombre impair
                    if (rowItems.size == 1 && !isMobile) {
                        Box(modifier = Modifier.flexGrow(1))
                    }
                }
            }
        }
    }
}